import { defineMessages } from 'react-intl';

export const messages: {
	designLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	designLabel: {
		id: 'design-search-result.label',
		defaultMessage: 'Design',
		description:
			'Badge label shown on a design search result card to identify the result type as a design file (e.g. from Figma or a similar design tool).',
	},
});
